module.exports = __webpack_public_path__ + "images/puzzle/Skeleton/PNG/Piece06.96e85f68c958417db78cac505267b5fc.png";